// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__34Vkc","title":"BackImages_title__xrid5","images":"BackImages_images__1_rhP"};